//#region src/supabase.types.ts
const Constants = {
	graphql_public: { Enums: {} },
	public: { Enums: {
		business_type: [
			"device_user",
			"service_provider",
			"manufacturer"
		],
		case_origin: [
			"user",
			"trigger",
			"portal"
		],
		case_status: [
			"reported",
			"assessed",
			"started",
			"archived",
			"resolved"
		],
		case_type: [
			"accident",
			"anomaly",
			"damage",
			"improvement"
		],
		cases_history_type: [
			"case_item",
			"case_to_part",
			"case_to_case_tag",
			"case_to_maintenance",
			"case_to_service_job"
		],
		cases_insights_period: [
			"day",
			"week",
			"month"
		],
		cases_to_maintenances_origin: ["case", "maintenance"],
		chart_type: [
			"line",
			"area",
			"bar"
		],
		connection_status: [
			"pending",
			"online",
			"offline"
		],
		data_trigger_action: ["case", "maintenance"],
		data_trigger_operator: [
			"greater",
			"less",
			"equal",
			"not_equal",
			"greater_equal",
			"less_equal"
		],
		data_trigger_target_table: [
			"device_scalar_values",
			"device_errors",
			"device_orders"
		],
		data_trigger_threshold_source: [
			"fixed",
			"step",
			"two_sigma"
		],
		data_trigger_transformation: [
			"mean",
			"stddev",
			"max",
			"min",
			"sum",
			"count"
		],
		db_operation: [
			"INSERT",
			"UPDATE",
			"DELETE"
		],
		deployment_role: [
			"admin",
			"technician",
			"viewer",
			"none",
			"end_customer"
		],
		device_order_status: [
			"pending",
			"started",
			"finished",
			"aborted",
			"cancelled",
			"missing"
		],
		devices_history_type: [
			"case_item",
			"maintenance_item",
			"maintenance",
			"history_event",
			"service_job"
		],
		global_role: ["admin", "none"],
		inventory_action: [
			"add",
			"remove",
			"change",
			"move",
			"isolate",
			"assemble",
			"disassemble"
		],
		inventory_location_type: ["source", "target"],
		maintenance_item_status: [
			"pending",
			"started",
			"skipped",
			"completed",
			"failed"
		],
		maintenance_items_to_parts_type: ["proposed", "executed"],
		maintenance_status: [
			"scheduled",
			"started",
			"finished",
			"skipped"
		],
		maintenance_strategies_history_type: ["maintenance_strategy"],
		maintenances_finished_device_utilization_period: [
			"day",
			"week",
			"month"
		],
		maintenances_history_type: [
			"maintenance",
			"maintenance_to_device",
			"maintenance_approval",
			"maintenance_to_maintenance_tag",
			"case_to_maintenance",
			"maintenance_to_maintenance_parent",
			"maintenance_to_maintenance_child",
			"maintenance_to_service_job"
		],
		part_location_type: [
			"inventory",
			"incoming",
			"staging"
		],
		part_usage_type: [
			"disassembly",
			"assembly",
			"cleaning",
			"repair",
			"calibration",
			"update",
			"unspecified"
		],
		service_jobs_history_type: [
			"service_job",
			"case_to_service_job",
			"maintenance_to_service_job",
			"user_to_service_job"
		],
		workspace_role: [
			"admin",
			"viewer",
			"associate",
			"none"
		]
	} },
	storage: { Enums: { buckettype: [
		"STANDARD",
		"ANALYTICS",
		"VECTOR"
	] } }
};
let BusinessType = /* @__PURE__ */ function(BusinessType) {
	BusinessType["device_user"] = "device_user";
	BusinessType["service_provider"] = "service_provider";
	BusinessType["manufacturer"] = "manufacturer";
	return BusinessType;
}({});
let CaseOrigin = /* @__PURE__ */ function(CaseOrigin) {
	CaseOrigin["user"] = "user";
	CaseOrigin["trigger"] = "trigger";
	CaseOrigin["portal"] = "portal";
	return CaseOrigin;
}({});
let CaseStatus = /* @__PURE__ */ function(CaseStatus) {
	CaseStatus["reported"] = "reported";
	CaseStatus["assessed"] = "assessed";
	CaseStatus["started"] = "started";
	CaseStatus["archived"] = "archived";
	CaseStatus["resolved"] = "resolved";
	return CaseStatus;
}({});
let CaseType = /* @__PURE__ */ function(CaseType) {
	CaseType["accident"] = "accident";
	CaseType["anomaly"] = "anomaly";
	CaseType["damage"] = "damage";
	CaseType["improvement"] = "improvement";
	return CaseType;
}({});
let CaseHistoryType = /* @__PURE__ */ function(CaseHistoryType) {
	CaseHistoryType["case_item"] = "case_item";
	CaseHistoryType["case_to_part"] = "case_to_part";
	CaseHistoryType["case_to_case_tag"] = "case_to_case_tag";
	CaseHistoryType["case_to_maintenance"] = "case_to_maintenance";
	CaseHistoryType["case_to_service_job"] = "case_to_service_job";
	return CaseHistoryType;
}({});
let CaseInsightPeriod = /* @__PURE__ */ function(CaseInsightPeriod) {
	CaseInsightPeriod["day"] = "day";
	CaseInsightPeriod["week"] = "week";
	CaseInsightPeriod["month"] = "month";
	return CaseInsightPeriod;
}({});
let CaseToMaintenanceOrigin = /* @__PURE__ */ function(CaseToMaintenanceOrigin) {
	CaseToMaintenanceOrigin["case"] = "case";
	CaseToMaintenanceOrigin["maintenance"] = "maintenance";
	return CaseToMaintenanceOrigin;
}({});
let ChartType = /* @__PURE__ */ function(ChartType) {
	ChartType["line"] = "line";
	ChartType["area"] = "area";
	ChartType["bar"] = "bar";
	return ChartType;
}({});
let ConnectionStatus = /* @__PURE__ */ function(ConnectionStatus) {
	ConnectionStatus["pending"] = "pending";
	ConnectionStatus["online"] = "online";
	ConnectionStatus["offline"] = "offline";
	return ConnectionStatus;
}({});
let DatumTriggerAction = /* @__PURE__ */ function(DatumTriggerAction) {
	DatumTriggerAction["case"] = "case";
	DatumTriggerAction["maintenance"] = "maintenance";
	return DatumTriggerAction;
}({});
let DatumTriggerOperator = /* @__PURE__ */ function(DatumTriggerOperator) {
	DatumTriggerOperator["greater"] = "greater";
	DatumTriggerOperator["less"] = "less";
	DatumTriggerOperator["equal"] = "equal";
	DatumTriggerOperator["not_equal"] = "not_equal";
	DatumTriggerOperator["greater_equal"] = "greater_equal";
	DatumTriggerOperator["less_equal"] = "less_equal";
	return DatumTriggerOperator;
}({});
let DatumTriggerTargetTable = /* @__PURE__ */ function(DatumTriggerTargetTable) {
	DatumTriggerTargetTable["device_scalar_values"] = "device_scalar_values";
	DatumTriggerTargetTable["device_errors"] = "device_errors";
	DatumTriggerTargetTable["device_orders"] = "device_orders";
	return DatumTriggerTargetTable;
}({});
let DatumTriggerThresholdSource = /* @__PURE__ */ function(DatumTriggerThresholdSource) {
	DatumTriggerThresholdSource["fixed"] = "fixed";
	DatumTriggerThresholdSource["step"] = "step";
	DatumTriggerThresholdSource["two_sigma"] = "two_sigma";
	return DatumTriggerThresholdSource;
}({});
let DatumTriggerTransformation = /* @__PURE__ */ function(DatumTriggerTransformation) {
	DatumTriggerTransformation["mean"] = "mean";
	DatumTriggerTransformation["stddev"] = "stddev";
	DatumTriggerTransformation["max"] = "max";
	DatumTriggerTransformation["min"] = "min";
	DatumTriggerTransformation["sum"] = "sum";
	DatumTriggerTransformation["count"] = "count";
	return DatumTriggerTransformation;
}({});
let DbOperation = /* @__PURE__ */ function(DbOperation) {
	DbOperation["INSERT"] = "INSERT";
	DbOperation["UPDATE"] = "UPDATE";
	DbOperation["DELETE"] = "DELETE";
	return DbOperation;
}({});
let DeploymentRole = /* @__PURE__ */ function(DeploymentRole) {
	DeploymentRole["admin"] = "admin";
	DeploymentRole["technician"] = "technician";
	DeploymentRole["viewer"] = "viewer";
	DeploymentRole["none"] = "none";
	DeploymentRole["end_customer"] = "end_customer";
	return DeploymentRole;
}({});
let DeviceOrderStatus = /* @__PURE__ */ function(DeviceOrderStatus) {
	DeviceOrderStatus["pending"] = "pending";
	DeviceOrderStatus["started"] = "started";
	DeviceOrderStatus["finished"] = "finished";
	DeviceOrderStatus["aborted"] = "aborted";
	DeviceOrderStatus["cancelled"] = "cancelled";
	DeviceOrderStatus["missing"] = "missing";
	return DeviceOrderStatus;
}({});
let DeviceHistoryType = /* @__PURE__ */ function(DeviceHistoryType) {
	DeviceHistoryType["case_item"] = "case_item";
	DeviceHistoryType["maintenance_item"] = "maintenance_item";
	DeviceHistoryType["maintenance"] = "maintenance";
	DeviceHistoryType["history_event"] = "history_event";
	DeviceHistoryType["service_job"] = "service_job";
	return DeviceHistoryType;
}({});
let GlobalRole = /* @__PURE__ */ function(GlobalRole) {
	GlobalRole["admin"] = "admin";
	GlobalRole["none"] = "none";
	return GlobalRole;
}({});
let InventoryAction = /* @__PURE__ */ function(InventoryAction) {
	InventoryAction["add"] = "add";
	InventoryAction["remove"] = "remove";
	InventoryAction["change"] = "change";
	InventoryAction["move"] = "move";
	InventoryAction["isolate"] = "isolate";
	InventoryAction["assemble"] = "assemble";
	InventoryAction["disassemble"] = "disassemble";
	return InventoryAction;
}({});
let InventoryLocationType = /* @__PURE__ */ function(InventoryLocationType) {
	InventoryLocationType["source"] = "source";
	InventoryLocationType["target"] = "target";
	return InventoryLocationType;
}({});
let MaintenanceItemStatus = /* @__PURE__ */ function(MaintenanceItemStatus) {
	MaintenanceItemStatus["pending"] = "pending";
	MaintenanceItemStatus["started"] = "started";
	MaintenanceItemStatus["skipped"] = "skipped";
	MaintenanceItemStatus["completed"] = "completed";
	MaintenanceItemStatus["failed"] = "failed";
	return MaintenanceItemStatus;
}({});
let MaintenanceItemToPartType = /* @__PURE__ */ function(MaintenanceItemToPartType) {
	MaintenanceItemToPartType["proposed"] = "proposed";
	MaintenanceItemToPartType["executed"] = "executed";
	return MaintenanceItemToPartType;
}({});
let MaintenanceStatus = /* @__PURE__ */ function(MaintenanceStatus) {
	MaintenanceStatus["scheduled"] = "scheduled";
	MaintenanceStatus["started"] = "started";
	MaintenanceStatus["finished"] = "finished";
	MaintenanceStatus["skipped"] = "skipped";
	return MaintenanceStatus;
}({});
let MaintenanceStrategyHistoryType = /* @__PURE__ */ function(MaintenanceStrategyHistoryType) {
	MaintenanceStrategyHistoryType["maintenance_strategy"] = "maintenance_strategy";
	return MaintenanceStrategyHistoryType;
}({});
let MaintenanceFinishedDeviceUtilizationPeriod = /* @__PURE__ */ function(MaintenanceFinishedDeviceUtilizationPeriod) {
	MaintenanceFinishedDeviceUtilizationPeriod["day"] = "day";
	MaintenanceFinishedDeviceUtilizationPeriod["week"] = "week";
	MaintenanceFinishedDeviceUtilizationPeriod["month"] = "month";
	return MaintenanceFinishedDeviceUtilizationPeriod;
}({});
let MaintenanceHistoryType = /* @__PURE__ */ function(MaintenanceHistoryType) {
	MaintenanceHistoryType["maintenance"] = "maintenance";
	MaintenanceHistoryType["maintenance_to_device"] = "maintenance_to_device";
	MaintenanceHistoryType["maintenance_approval"] = "maintenance_approval";
	MaintenanceHistoryType["maintenance_to_maintenance_tag"] = "maintenance_to_maintenance_tag";
	MaintenanceHistoryType["case_to_maintenance"] = "case_to_maintenance";
	MaintenanceHistoryType["maintenance_to_maintenance_parent"] = "maintenance_to_maintenance_parent";
	MaintenanceHistoryType["maintenance_to_maintenance_child"] = "maintenance_to_maintenance_child";
	MaintenanceHistoryType["maintenance_to_service_job"] = "maintenance_to_service_job";
	return MaintenanceHistoryType;
}({});
let PartLocationType = /* @__PURE__ */ function(PartLocationType) {
	PartLocationType["inventory"] = "inventory";
	PartLocationType["incoming"] = "incoming";
	PartLocationType["staging"] = "staging";
	return PartLocationType;
}({});
let PartUsageType = /* @__PURE__ */ function(PartUsageType) {
	PartUsageType["disassembly"] = "disassembly";
	PartUsageType["assembly"] = "assembly";
	PartUsageType["cleaning"] = "cleaning";
	PartUsageType["repair"] = "repair";
	PartUsageType["calibration"] = "calibration";
	PartUsageType["update"] = "update";
	PartUsageType["unspecified"] = "unspecified";
	return PartUsageType;
}({});
let ServiceJobHistoryType = /* @__PURE__ */ function(ServiceJobHistoryType) {
	ServiceJobHistoryType["service_job"] = "service_job";
	ServiceJobHistoryType["case_to_service_job"] = "case_to_service_job";
	ServiceJobHistoryType["maintenance_to_service_job"] = "maintenance_to_service_job";
	ServiceJobHistoryType["user_to_service_job"] = "user_to_service_job";
	return ServiceJobHistoryType;
}({});
let WorkspaceRole = /* @__PURE__ */ function(WorkspaceRole) {
	WorkspaceRole["admin"] = "admin";
	WorkspaceRole["viewer"] = "viewer";
	WorkspaceRole["associate"] = "associate";
	WorkspaceRole["none"] = "none";
	return WorkspaceRole;
}({});
let Buckettype = /* @__PURE__ */ function(Buckettype) {
	Buckettype["STANDARD"] = "STANDARD";
	Buckettype["ANALYTICS"] = "ANALYTICS";
	Buckettype["VECTOR"] = "VECTOR";
	return Buckettype;
}({});
//#endregion
export { Buckettype, BusinessType, CaseHistoryType, CaseInsightPeriod, CaseOrigin, CaseStatus, CaseToMaintenanceOrigin, CaseType, ChartType, ConnectionStatus, Constants, DatumTriggerAction, DatumTriggerOperator, DatumTriggerTargetTable, DatumTriggerThresholdSource, DatumTriggerTransformation, DbOperation, DeploymentRole, DeviceHistoryType, DeviceOrderStatus, GlobalRole, InventoryAction, InventoryLocationType, MaintenanceFinishedDeviceUtilizationPeriod, MaintenanceHistoryType, MaintenanceItemStatus, MaintenanceItemToPartType, MaintenanceStatus, MaintenanceStrategyHistoryType, PartLocationType, PartUsageType, ServiceJobHistoryType, WorkspaceRole };
